<p-dialog
  class="custom-confirm-dialog"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [position]="'topright'"
  [style]="{ width: '33vw', height: '100vh' }"
  (onHide)="onClose()"
>
  <ng-template #header>
    <div class="headerSection">
      <div class="text-l heading">All Notifications</div>
      <div class="heading" *ngIf="showNotifications">
        {{ totalNotifs }} notification{{ totalNotifs !== 1 ? 's' : '' }} •
        {{ unread }} unread
      </div>
    </div>
  </ng-template>

  <div
    class="card d-flex flex-column m-0"
    *ngIf="showFilterBar || showNotifications"
  >
    <div class="filters" [formGroup]="categoriesForm" *ngIf="showFilterBar">
      <div class="form-select-control input-container filter-search">
        <p-multiSelect
          class="px-0"
          [options]="categoriesOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Categories"
          [showToggleAll]="false"
          formControlName="categoriesOptions"
          appendTo="body"
          inputId="float-label"
          [maxSelectedLabels]="5"
          [selectedItemsLabel]="selectedLabelTemplate"
          [hidden]="isLoading"
        >
        </p-multiSelect>
        <label for="float-label" class="label" [hidden]="isLoading"
          >Category</label
        >
      </div>
      <div>
        <button
          class="manage-notification"
          (click)="navigateSubscribeNotifications()"
        >
          <svg width="14" height="14" class="cursor-pointer">
            <use
              [attr.xlink:href]="svgPath + 'sprite.svg#manage-notifications'"
            ></use>
          </svg>
          Manage Notifications
        </button>
      </div>
    </div>

    <button
      *ngIf="showNewNotificationBanner && !isLoading"
      class="new-notification-banner"
      (click)="onNewNotificationClick()"
      aria-label="Load new notifications"
    >
      <span class="arrow-up-icon">↑</span>
      <span>New Notification</span>
    </button>

    <div class="notifications-body">
      <div *ngIf="isLoading" class="loading-overlay">
        <div class="progress-bar-wrapper">
          <p-progressBar
            mode="indeterminate"
            [style]="{ height: '6px' }"
            color="rgb(255, 153, 0)"
          ></p-progressBar>
        </div>
      </div>

      <div
        #notificationScroller
        class="card-content notification-scroller"
        *ngIf="data.length > 0"
        cdkScrollable
        (scroll)="onScroll($event)"
      >
        <div *ngFor="let notification of data; let i = index">
          <div
            class="notification-item alert-category"
            [class.unread]="!notification.isRead"
          >
            <div
              class="notification-border"
              [ngClass]="(notification.subAlertName | alertCategory).cssClass"
            ></div>

            <div class="notification-content">
              <div class="notification-header">
                <h3 class="notification-title">
                  {{ notification.alertName ?? notification.subAlertName }}
                </h3>
                <span class="notification-time">{{
                  notification.eventTime | dateTime
                }}</span>
              </div>

              <p class="notification-reason">{{ notification.description }}</p>

              <div class="notification-footer">
                <div class="d-flex gap-2">
                  <span class="notification-vehicle">
                    {{
                      notification.registrationNumber ??
                        notification.vehicleCode
                    }}
                  </span>
                  <span
                    class="category-badge"
                    [ngClass]="
                      (notification.subAlertName | alertCategory).cssClass
                    "
                  >
                    {{ notification.subAlertName }}
                  </span>
                </div>
                <button
                  *ngIf="
                    notification.coordinates !== null &&
                    notification.coordinates !== undefined
                  "
                  (click)="toggleLocationPanel(notification, i)"
                  [class.active]="selectedLocationNotification === notification"
                  class="view-location d-flex mt-2"
                >
                  <svg width="15" height="15" class="cursor-pointer">
                    <use
                      [attr.xlink:href]="
                        svgPath + 'sprite.svg#notification-view-location'
                      "
                    ></use>
                  </svg>
                  View Location
                  <svg
                    width="10"
                    height="6"
                    class="location-arrow"
                    [class.expanded]="
                      selectedLocationNotification === notification
                    "
                  >
                    <use
                      [attr.xlink:href]="svgPath + 'sprite.svg#time-down-arrow'"
                    ></use>
                  </svg>
                </button>

                <div
                  *ngIf="selectedLocationNotification === notification"
                  class="location-panel mt-2"
                >
                  <div
                    *ngIf="mapLoadingNotification === notification"
                    class="map-loading"
                  >
                    <p-progressBar
                      mode="indeterminate"
                      [style]="{ height: '4px' }"
                      color="rgb(255, 153, 0)"
                    ></p-progressBar>
                  </div>
                  <div [id]="'location-map-' + i" class="location-map"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isFetchingMore" class="pt-1 pb-2">
          <p-progressBar
            mode="indeterminate"
            [style]="{ height: '6px' }"
            color="rgb(255, 153, 0)"
          ></p-progressBar>
        </div>
      </div>
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center no-notif"
      *ngIf="showFilterBar && !showNotifications && hasActiveFilter"
    >
      <svg width="72" height="72" class="cursor-pointer">
        <use
          [attr.xlink:href]="svgPath + 'sprite.svg#notification-bell-blue'"
        ></use>
      </svg>
      <div class="d-flex flex-column justify-content-center align-items-center">
        <span class="notif-live"> No notifications found </span>
        <span class="notif-subs">
          No notifications match your selected filters. Try adjusting your
          filter criteria.
        </span>
      </div>
    </div>
  </div>
  <div
    class="d-flex flex-column align-items-center justify-content-center no-notif"
    *ngIf="showNotSubscribed && !isLoading"
  >
    <svg width="72" height="72" class="cursor-pointer">
      <use
        [attr.xlink:href]="svgPath + 'sprite.svg#notification-bell-blue'"
      ></use>
    </svg>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <span class="notif-live"> Your notifications live here </span>
      <span class="notif-subs">
        Subscribe to notifications to keep track of your vehicle's key updates.
      </span>
    </div>
    <button
      class="subscribe-notification mt-2"
      (click)="navigateSubscribeNotifications()"
    >
      <svg width="15" height="15" class="cursor-pointer">
        <use
          [attr.xlink:href]="svgPath + 'sprite.svg#notification-bell-white'"
        ></use>
      </svg>
      Subscribe Notification
    </button>
  </div>
  <div
    class="d-flex flex-column align-items-center justify-content-center no-notif"
    *ngIf="showNoNotifications && !hasActiveFilter && !isLoading"
  >
    <svg width="72" height="72" class="cursor-pointer">
      <use
        [attr.xlink:href]="svgPath + 'sprite.svg#notification-bell-blue'"
      ></use>
    </svg>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <span class="notif-live"> Your notifications live here </span>
      <span class="notif-subs">
        You'll see new alerts here as soon as important vehicle updates are
        available.
      </span>
    </div>
    <button
      class="subscribe-notification mt-2"
      (click)="navigateSubscribeNotifications()"
    >
      <svg width="15" height="15" class="cursor-pointer">
        <use
          [attr.xlink:href]="svgPath + 'sprite.svg#manage-notifications'"
        ></use>
      </svg>
      Manage Notification
    </button>
  </div>
  <div
    class="d-flex flex-column align-items-center justify-content-center no-notif"
    *ngIf="showNoPermission && !isLoading"
  >
    <svg width="72" height="72" class="cursor-pointer">
      <use
        [attr.xlink:href]="svgPath + 'sprite.svg#notification-bell-blue'"
      ></use>
    </svg>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <span class="notif-live"> Your notifications live here </span>
      <span class="notif-subs">
        No Notification or alert is assigned or configured for you
      </span>
    </div>
    <button class="notification-contact-us mt-2" (click)="navigateContactUs()">
      <svg width="15" height="15" class="cursor-pointer">
        <use
          [attr.xlink:href]="svgPath + 'sprite.svg#notification-contact-us'"
        ></use>
      </svg>
      Contact Us
    </button>
  </div>
</p-dialog>
